import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

import { showMessage } from '../Utils';

const mapStateToProps = (state) => ({
  isMobile: state.browser.lessThan.medium,
});

export default connect(mapStateToProps)(({ isMobile, url }) => {
  const [copied, setCopied] = useState(false);

  const targetUrl = url ?? window.location.href;

  const onClick = async () => {
    await navigator.clipboard.writeText(targetUrl);
    setCopied(true);
    showMessage.info('已複製網址到剪貼簿！');
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return isMobile ? (
    <Button
      size="tiny"
      icon={copied ? 'copy outline' : 'copy'}
      color="blue"
      onClick={onClick}
    />
  ) : (
    <Button
      size="tiny"
      content="複製網址"
      icon={copied ? 'copy outline' : 'copy'}
      labelPosition="left"
      color="blue"
      onClick={onClick}
    />
  );
});
